import {
  AnchoredPanelType,
  CheckBox,
  InfoBlockLayout,
  InfoBlockStatus,
  InputFormSidePanel,
  InputFormSidePanelProps,
  Select,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { MdsBackupPolicy } from "../../gen/clients/mchub-azure-api-client-mds";
import {
  mdsBackupPolicyMaxRetentionInDays,
  mdsBackupPolicyMinRetentionInDays,
  mysqlBackupSlots,
} from "../../helpers/resourceHelper";
import { IntegerInput } from "../IntegerInput/IntegerInput";

export const enum Fields {
  AutoBackupEnabled = "mysqlAutoBackupEnabled",
  RetentionInDays = "retentionInDays",
  WindowStartTime = "windowStartTime",
  PitrPolicy = "PitrPolicy",
}

// eslint-disable-next-line max-len
export interface MysqlBackupEditPanelProps extends Pick<InputFormSidePanelProps, "componentRef" | "onSubmit" | "onClose"> {
  targetId: string;
  dbBackup?: MdsBackupPolicy;
}

export const MysqlBackupEditPanel = ({
  targetId,
  dbBackup,
  onSubmit,
  onClose,
  componentRef,
}: MysqlBackupEditPanelProps): JSX.Element => {
  const [showBackupOptions, setShowBackupOptions] = React.useState(dbBackup?.isEnabled);
  const [defaultBackupSchedule,
    setDefaultBackupSchedule] = React.useState<string | undefined>(dbBackup?.windowStartTime);
  const [defaultRetentionPeriod, setDefaultRetentionPeriod] = React.useState(dbBackup?.retentionInDays);
  const [defaultPitrPolicy, setDefaultPitrPolicy] = React.useState(dbBackup?.pitrPolicy?.isEnabled);

  const info = {
    messageType: InfoBlockStatus.INFO,
    message: Messages.createMysql.managementTab.info.backupInfo(),
    infoLayout: InfoBlockLayout.Compact,
  };

  const onChangeShowBackUpOptions = (value: boolean): void => {
    setShowBackupOptions(value);
  };

  const windowStartOptions = mysqlBackupSlots.map(windowStartTime => ({
    id: windowStartTime,
    text: `${windowStartTime} ${Messages.common.utc()}`,
  }));

  return (
    <InputFormSidePanel
      anchorId={targetId}
      type={AnchoredPanelType.MEDIUM}
      title={Messages.createNewPanels.editMySqlBackupPlan.title()}
      onSubmit={onSubmit}
      onClose={onClose}
      componentRef={componentRef}
    >
      <CheckBox
        defaultValue={showBackupOptions}
        statusInfo={info}
        fieldName={Fields.AutoBackupEnabled}
        label={Messages.labels.enableAutomaticBackups()}
        onChange={onChangeShowBackUpOptions}
      />
      {showBackupOptions && (
      <>
        <IntegerInput
          fieldName={Fields.RetentionInDays}
          label={Messages.labels.backupRetentionPeriod()}
          tooltip={Messages.hints.tooltipMySQLBackupRetentionPeriod()}
          defaultValue={defaultRetentionPeriod}
          min={mdsBackupPolicyMinRetentionInDays}
          max={mdsBackupPolicyMaxRetentionInDays}
          onChange={setDefaultRetentionPeriod}
          required
        />
        <Select
          defaultValue={defaultBackupSchedule ? [defaultBackupSchedule] : undefined}
          required
          fieldName={Fields.WindowStartTime}
          label={Messages.labels.mySQLWindowStartTime()}
          options={windowStartOptions}
          onChange={setDefaultBackupSchedule}
          hideSearchBox
        />
        <CheckBox
          defaultValue={defaultPitrPolicy}
          fieldName={Fields.PitrPolicy}
          label={Messages.labels.pitrPolicy()}
          tooltip={Messages.hints.enablePitrPolicy()}
          onChange={setDefaultPitrPolicy}
        />
      </>
      )}
    </InputFormSidePanel>
  );
};
